import socket from '@/services/socket.js'

export default {
  /**
   * Get url settings by mode id.
   *
   * @param mode_id
   * @returns Promise
   */
  getByModeId(mode_id) {
    let action = '/url_setting/get_by_mode_id'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        mode_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data.url_settings)
      })
    })
  },

  /**
   * Create user url setting.
   *
   * @param mode_id
   * @param top_level_domain
   * @param mode
   * @returns Promise
   */
  create(mode_id, top_level_domain, mode) {
    let action = '/url_setting/add'
  
    let body = {
      mode_id,
      top_level_domain,
      action: mode,
      log: true,
      mask: true,
      is_customizable: false
    }
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        body
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data)
      })
    })
  },

  /**
   * Delete user url setting.
   *
   * @param mode_id
   * @param url_setting_id
   * @returns Promise
   */
  delete(mode_id, url_setting_id) {
    let action = '/url_setting/delete'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        mode_id,
        url_setting_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data)
      })
    })
  }
}